import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isGlobalUserLoggedIn } from "../utils/jwt";
import { GLOBAL_COUNTRIES, WHITELIST } from "../constants";


const SHOPIFY_AU_URL = "https://glymed.global";

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match ? match[2] : null;
};


export const useGeoRedirect = () => {
  const location = useLocation();

  useEffect(() => {
    const country = getCookie("geo_country");
    const path = location.pathname.toLowerCase();

    const isAllowed = WHITELIST.some((allowed) => path.startsWith(allowed));

    if (
      (GLOBAL_COUNTRIES.includes(country) || isGlobalUserLoggedIn()) &&
      !isAllowed
    ) {
      window.location.href = SHOPIFY_AU_URL;
    }
  }, [location]);
};
